const navItem = {
  about: {
    text: '2022_thsucc_nav_about',
    href: '#about'
  },
  timeline: {
    text: '2022_thsucc_nav_timeline',
    href: '#timeline'
  },
  prizes: {
    text: '2022_thsucc_nav_prizes',
    href: '#prizes'
  },
  prizesAndOpportunitied: {
    text: '2022_thsucc_nav_prizes_and_opportunitied',
    href: '#prizes'
  },
  tutors: {
    text: '2022_thsucc_nav_mentors',
    href: '#tutors'
  },
  partner: {
    text: '2022_thsucc_nav_partners',
    href: '#partners'
  },
  faq: {
    text: '2022_thsucc_nav_faq',
    href: '#FAQ'
  },
  contact: {
    text: '2022_thsucc_nav_contact',
    href: '#contact'
  },
  careers: {
    text: '2022_thsucc_nav_careers',
    href: '/',
    target: '_blank'
  }
}

const sighUpLink = "https://techatshopee.formstack.com/forms/th_shopee_business_case_challenge_2022"

function message () {
  return {
    application: {
      title: 'Shopee Thailand Ultimate Case Challenge 2022',
      desc: 'The Shopee Ultimate Case Challenge is an annual business case competition, designed to test inventive and innovative students with real-world problems.With the challenge’s unique mentorship program and multi-round format, you will get to demonstrate your business acumen and resourcefulness with your team, and create solutions that will make the difference in our markets across the globe.If you’re ready to lead the way in e-commerce and tech, join us at the Shopee!',
      startDate: 'April 2022',
      endDate: '28 June 2021'
    },
    navbar: [
      navItem.about,
      navItem.timeline,
      navItem.prizesAndOpportunitied,
      navItem.faq,
      navItem.partner,
      navItem.contact,
      navItem.careers
    ],
    banner: {
      text: '2022_thsucc_banner_text',
      registerBtn: '2022_thsucc_banner_sign_up',
      sighUpLink,
      explain: '2022_thsucc_banner_explain',
      isTH: true
    },
    sighUpBtn: {
      sighUpLink,
      btnText: '2022_thsucc_banner_sign_up'
    },
    countDown: '2022_thsucc_countdown',
    about: {
      title: '2022_thsucc_about_title',
      desc: '2022_thsucc_about_content'
    },
    aim: {
      title: 'idsucc_title_objectives',
      list: [{
        desc: '2022_thsucc_objectives_text1',
        icon: require('@succ/public/images/aim/bg-1.svg')
      }, {
        desc: '2022_thsucc_objectives_text2',
        icon: require('@succ/public/images/aim/bg-2.svg')
      }, {
        desc: '2022_thsucc_objectives_text3',
        icon: require('@succ/public/images/aim/bg-3.svg')
      }],
      cardList: [{
        title: '2022_thsucc_objectives_list_title_1',
        desc: '2022_thsucc_objectives_list_desc_1',
        icon: require('@succ/public/images/aim/bg-4.svg')
      }, {
        title: '2022_thsucc_objectives_list_title_2',
        desc: '2022_thsucc_objectives_list_desc_2',
        icon: require('@succ/public/images/aim/bg-5.svg')
      }, {
        title: '2022_thsucc_objectives_list_title_3',
        desc: '2022_thsucc_objectives_list_desc_3',
        icon: require('@succ/public/images/aim/bg-6.svg')
      }, {
        title: '2022_thsucc_objectives_list_title_4',
        desc: '2022_thsucc_objectives_list_desc_4',
        icon: require('@succ/public/images/aim/bg-7.svg')
      }]
    },
    timeline: {
      title: '2022_thsucc_nav_timeline',
      list: [{
        date: '2022_thsucc_timeline_date_1',
        title: '2022_thsucc_timeline_title_1',
        desc: ['2022_thsucc_timeline_desc_1', '2022_thsucc_timeline_desc_1_02']
      }, {
        date: '2022_thsucc_timeline_date_2',
        title: '2022_thsucc_timeline_title_2',
        desc: ['2022_thsucc_timeline_desc_2']
      }, {
        date: '2022_thsucc_timeline_date_3',
        title: '2022_thsucc_timeline_title_3',
        desc: ['2022_thsucc_timeline_desc_3_01', '2022_thsucc_timeline_desc_3_02']
      }, {
        date: '2022_thsucc_timeline_date_4',
        title: '2022_thsucc_timeline_title_4',
        desc: ['2022_thsucc_timeline_desc_4']
      }, {
        date: '2022_thsucc_timeline_date_5',
        title: '2022_thsucc_timeline_title_5',
        desc: ['2022_thsucc_timeline_desc_5_01', '2022_thsucc_timeline_desc_5_02']
      }, {
        date: '2022_thsucc_timeline_date_6',
        title: '2022_thsucc_timeline_title_6',
        desc: ['2022_thsucc_timeline_desc_6']
      }],
      explain: '2022_thsucc_timeline_explain'
    },
    tutors: {
      title: '2022_thsucc_mentors_title',
      list: [[{
        image: require('@succ/public/images/tutors/tutor-th-1.jpg'),
        desc: '2022_thsucc_mentors_desc_1',
      }, {
        image: require('@succ/public/images/tutors/tutor-th-2.jpg'),
        desc: '2022_thsucc_mentors_desc_2',
      }, {
        image: require('@succ/public/images/tutors/tutor-th-3.jpg'),
        desc: '2022_thsucc_mentors_desc_3',
      }], [{
        image: require('@succ/public/images/tutors/tutor-th-4.jpg'),
        desc: '2022_thsucc_mentors_desc_4',
      }, {
        image: require('@succ/public/images/tutors/tutor-th-5.jpg'),
        desc: '2022_thsucc_mentors_desc_5',
      }, {
        image: require('@succ/public/images/tutors/tutor-th-6.jpg'),
        desc: '2022_thsucc_mentors_desc_6',
      }]],
    },
    prizes: {
      title: '2022_thsucc_title_prizes',
      desc: '2022_thsucc_prize_desc',
      desc2: '2022_thsucc_prize_desc_2',
      list: [{
        title: '2022_thsucc_prize_title_1',
        money: '2022_thsucc_prize_money_1',
      }, {
        title: '2022_thsucc_prize_title_2',
        money: '2022_thsucc_prize_money_2',
      }, {
        title: '2022_thsucc_prize_title_3',
        money: '2022_thsucc_prize_money_3',
      }],
      explain: '2022_thsucc_prize_explain'
    },
    faqs: {
      title: '2022_thsucc_title_faqs',
      sections: [{
        title: '2022_thsucc_faq_title_about',
        list: [{
          question: '2022_thsucc_faq_about_q1',
          desc: ['2022_thsucc_faq_about_a1']
        }, {
          question: '2022_thsucc_faq_about_q2',
          desc: ['2022_thsucc_faq_about_a2']
        }, {
          question: '2022_thsucc_faq_about_q3',
          desc: ['2022_thsucc_faq_about_a3']
        }, {
          question: '2022_thsucc_faq_about_q4',
          desc: ['2022_thsucc_faq_about_a4']
        }, {
          question: '2022_thsucc_faq_about_q5',
          desc: ['2022_thsucc_faq_about_a5']
        }, {
          question: '2022_thsucc_faq_about_q6',
          desc: ['2022_thsucc_faq_about_a6']
        }]
      }, {
        title: '2022_thsucc_faq_title_eligibility',
        list: [{
          question: '2022_thsucc_faq_eligibility_q1',
          desc: ['2022_thsucc_faq_eligibility_a1']
        }, {
          question: '2022_thsucc_faq_eligibility_q2',
          desc: ['2022_thsucc_faq_eligibility_a2']
        }, {
          question: '2022_thsucc_faq_eligibility_q3',
          desc: ['2022_thsucc_faq_eligibility_a3']
        }, {
          question: '2022_thsucc_faq_eligibility_q4',
          desc: ['2022_thsucc_faq_eligibility_a4']
        }, {
          question: '2022_thsucc_faq_eligibility_q5',
          desc: ['2022_thsucc_faq_eligibility_a5']
        }, {
          question: '2022_thsucc_faq_eligibility_q6',
          desc: ['2022_thsucc_faq_eligibility_a6']
        }, {
          question: '2022_thsucc_faq_eligibility_q7',
          desc: ['2022_thsucc_faq_eligibility_a7']
        }, {
          question: '2022_thsucc_faq_eligibility_q8',
          desc: ['2022_thsucc_faq_eligibility_a8']
        }, {
          question: '2022_thsucc_faq_eligibility_q9',
          desc: ['2022_thsucc_faq_eligibility_a9']
        }, {
          question: '2022_thsucc_faq_eligibility_q10',
          desc: ['2022_thsucc_faq_eligibility_a10']
        }]
      }, {
        title: '2022_thsucc_faq_title_registration',
        list: [{
          question: '2022_thsucc_faq_registration_q1',
          desc: ['2022_thsucc_faq_registration_a1']
        }, {
          question: '2022_thsucc_faq_registration_q2',
          desc: ['2022_thsucc_faq_registration_a2']
        }, {
          question: '2022_thsucc_faq_registration_q3',
          desc: ['2022_thsucc_faq_registration_a3']
        }, {
          question: '2022_thsucc_faq_registration_q4',
          desc: ['2022_thsucc_faq_registration_a4']
        }, {
          question: '2022_thsucc_faq_registration_q5',
          desc: ['2022_thsucc_faq_registration_a5']
        }]
      }, {
        title: '2022_thsucc_faq_title_mentorship',
        list: [{
          question: '2022_thsucc_faq_mentorship_q1',
          desc: ['2022_thsucc_faq_mentorship_a1']
        }, {
          question: '2022_thsucc_faq_mentorship_q2',
          desc: ['2022_thsucc_faq_mentorship_a2']
        }, {
          question: '2022_thsucc_faq_mentorship_q3',
          desc: ['2022_thsucc_faq_mentorship_a3']
        }]
      }]
    },
    chance: {
      title: '2022_thsucc_title_chance',
      list: [{
        question: '2022_thsucc_chance_title_1',
        answers: ['2022_thsucc_chance_desc_1_1', '2022_thsucc_chance_desc_1_2']
      }, {
        question: '2022_thsucc_chance_title_2',
        answers: ['2022_thsucc_chance_desc_2_1', '2022_thsucc_chance_desc_2_2', '2022_thsucc_chance_desc_2_3', '2022_thsucc_chance_desc_2_4']
      }, {
        question: '2022_thsucc_chance_title_3',
        answers: ['2022_thsucc_chance_desc_3_1', '2022_thsucc_chance_desc_3_2', '2022_thsucc_chance_desc_3_3']
      }],
      explain: '2022_thsucc_chance_explain'
    },
    contact: {
      // title: 'succ_title_contact',
      desc: [
        '2022_thsucc_contact_desc_1'
       ],
      btn: '2022_thsucc_contact_btn',
      btnLink: 'mailto:succ.th@shopee.com'
    },
    footer: {
      logoStatic: true,
      follow: 'idsucc_follow_us',
      social: [{
        href: 'https://www.facebook.com/shopeecareers.th',
        name: 'facebook',
        icon: require('@/assets/images/icon-facebook.svg')
      }, {
        href: 'https://www.instagram.com/shopeecareersth/?hl=en',
        name: 'instagram',
        icon: require('@/assets/images/icon-instagram.svg')
      }, {
        href: 'https://linkedin.com/company/shopee',
        name: 'linkedin',
        icon: require('@/assets/images/icon-linkedin.svg')
      }],
      links: [[
        navItem.about,
        navItem.faq,
        navItem.careers
      ], [
        navItem.timeline,
        navItem.partner,
      ], [
        navItem.prizesAndOpportunitied,
        navItem.contact,
      ]],
      tc: 'pdf/th/succ-terms-and-conditions.pdf',
      privacyPolicy: 'pdf/th/succ-terms-and-conditions.pdf',
      copyright: 'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.'
    }
  }
}

export default message;
